import { GridCellProps } from '@progress/kendo-react-grid';
import GLCodeDropDownCell from './GlCodeDropdownCell';
import ItemNumberCell from './ItemNumberCell';
import PriceCell from './PriceCell';
import QuantityReceiveCell from './QuantityReceiveCell';
import TaxableCell from './TaxableCell';
import UOMCell from './UOMCell';

const BulkAddValueCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { field } = dataItem;

  if (field === 'productItemNum' || field === 'description') {
    return <ItemNumberCell {...props} />;
  } else if (field === 'isTaxable') {
    return <TaxableCell {...props} />;
  } else if (field === 'quantityReceived') {
    return <QuantityReceiveCell {...props} />;
  } else if (field === 'glCd') {
    return <GLCodeDropDownCell {...props} />;
  } else if (field === 'uom') {
    return <UOMCell {...props} />;
  } else if (field === 'priceAmt') {
    return <PriceCell {...props} />;
  }
  return <></>;
};

export default BulkAddValueCell;
